"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.useManageStrategyNodeGuidelineValidationSchema = void 0;
const Yup = __importStar(require("yup"));
const manage_guideline_dialog_form_constants_1 = require("./manage-guideline-dialog-form.constants");
const global_tree_edit_warning_form_constants_1 = require("../../components/global-tree-edit-warning/global-tree-edit-warning-form.constants");
const localization_1 = require("../../../localization");
const store_1 = require("../../../store");
const useManageStrategyNodeGuidelineValidationSchema = () => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const shouldShowGlobalTreeEditWarning = (0, store_1.useShouldShowGlobalTreeEditWarning)();
    return Yup.object().shape({
        [manage_guideline_dialog_form_constants_1.ManageGuidelineFormFieldNames.Guideline]: Yup.string()
            .required(t({ key: 'VALIDATION_REQUIRED' }))
            .max(2000, t({ key: 'VALIDATION_NOT_EXCEED_LIMIT_CHARACTERS', values: { limit: '2000' } })),
        [global_tree_edit_warning_form_constants_1.GlobalTreeEditWarningFormFieldNames.isGlobalStrategyReplacementAccepted]: Yup.boolean().test('is-accepted-global-strategy-replacement', '', (value) => {
            if (!shouldShowGlobalTreeEditWarning)
                return true;
            return Boolean(value);
        }),
    });
};
exports.useManageStrategyNodeGuidelineValidationSchema = useManageStrategyNodeGuidelineValidationSchema;
